import Axios from '@/utils/axios'
const URL = '/atendimento-hibrido'

export default {
  validateTokenClinica: (token) => {
    return Axios.post(`${URL}/validate-token`, { token })
  },
  validateCpf: ({ cpf, token }) => {
    return Axios.post(`${URL}/verifica-cpf`, { cpf, token })
  },
  entrarNaFila: idAso => {
    return Axios.post(`${URL}/entrar-na-fila/`, { idAso })
  }
}
